export default __webpack_public_path__ + "static/media/artificial-intelligence.52ec9c74.svg";